import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CategoryOptionService } from './category-option.service';

export interface SearchOption {
  key: string;
  label: string;
  items: Array<any>;
  service: string;
  defaultItem?: any;
  checked?: number;
}

@Component({
  selector: 'app-category-option',
  templateUrl: './category-option.component.html',
  styleUrls: ['./category-option.component.scss'],
  providers: [CategoryOptionService],
})
export class CategoryOptionComponent implements OnInit, OnChanges {
  @Input() defaultOption;
  @Input() selected: Object = { city_id: 0, salary_id: 0 };
  @Input() setOptions: Array<string>;// 设置配置项   找人才
  @Output() jobSelectType: any = new EventEmitter();
  // @Output() selectedChange: EventEmitter<Object> = new EventEmitter(); [(selected)] [(model)] => input:model output:modelChange

  public display: boolean = false;//打开关闭模态框
  public defaultOptions: SearchOption[] = [
    { key: 'city_id', label: '工作地点', items: [], service: 'getCategoryCity', defaultItem: { id: 0, name: '全国' } },
    { key: 'education_id', label: '学历要求', items: [], service: 'getCategoryDegree', defaultItem: { id: 0, name: '不限' } },
    { key: 'nature_id', label: '公司性质', items: [], service: 'getCategoryNature', defaultItem: { id: 0, name: '不限' } },
    { key: 'sex', label: '性别', items: [], service: 'getSexList', defaultItem: { id: 0, name: '不限' } },
    { key: 'jobType', label: '岗位性质', items: [], service: 'getCategoryJobType', defaultItem: { id: 0, name: '不限' } },
    { key: 'salary_id', label: '薪资范围', items: [], service: 'getCategorySalary', defaultItem: { id: 0, name: '不限' } },
    { key: 'industry_id', label: '行业领域', items: [], service: 'getCategoryIndustry', defaultItem: { id: 0, name: '不限' } },
    { key: 'position_industry_pid', label: '岗位分类', items: [], service: 'getCategoryJobClass', defaultItem: { id: 0, name: '不限' } },
    { key: 'position_industry_cid', label: '岗位类别', items: [], service: '', defaultItem: { id: 0, name: '不限' } },
    { key: 'position_hope_pid', label: '期望岗位', items: [], service: 'getHopeJobClassData', defaultItem: { id: 0, name: '不限' } },
    { key: 'position_hope_id', label: '期望类别', items: [], service: '', defaultItem: { id: 0, name: '不限' } }
  ];
  public selectOptions: SearchOption[];
  constructor(
    public _categoryOption: CategoryOptionService
  ) { }
  ngOnInit() {
    this.selectOptions = this.defaultOptions.filter(rec => this.setOptions.findIndex(ret => ret === rec.key) !== -1);
    // let tmpItem = Object.keys(this.selected);
    this.selectOptions.map(rec => {
      if (rec.service) {
        this._categoryOption[rec.service]().then(data => {
          rec.items = [rec.defaultItem].concat(data.data);
          let pid; let cid;
          if (rec.key === 'position_industry_pid') {
            pid = 'position_industry_pid';
            cid = 'position_industry_cid';
          } else if (rec.key === 'position_hope_pid') {
            pid = 'position_hope_pid';
            cid = 'position_hope_id';
          }
          if (rec.key === "city_id" && this.selected['city']) {
            let dd = rec.items.find(ret => ret.name === this.selected['city']);
            this.selected = Object.assign({ city_id: dd.id }, this.selected);
            delete this.selected['city'];
          }
          rec.checked = this.selected[rec.key] ? (+this.selected[rec.key]) : 0;
          this.onInitChildren(pid, cid, rec); //处理期望岗位和岗位类型children
        });
      } else {
        rec.items = [rec.defaultItem];
      }
      rec.checked = this.selected[rec.key] ? (+this.selected[rec.key]) : 0;
    })
  }
  //处理期望岗位和岗位类型children
  onInitChildren(pid, cid, rec) {
    if (this.selected[pid]) {
      let tmp = rec.items;
      if (tmp.find(reb => (+reb.id) == (+this.selected[pid])).children) {
        let tmpList = tmp.find(reb => (+reb.id) == (+this.selected[pid])).children;
        this.selectOptions.find(rpt => rpt.key === cid).items = [{ id: 0, name: '不限' }].concat(tmpList);
        this.selectOptions.find(rpt => rpt.key === cid).checked = this.selected[cid];
      } else {
        this.selectOptions.find(rpt => rpt.key === cid).items = [{ id: 0, name: '不限' }];
        this.selectOptions.find(rpt => rpt.key === cid).checked = 0;
      }
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['selected']['currentValue']) {
      if (this.selectOptions) {
        if (this.selected['city']) {
          let cc = this.selectOptions.find(rec => rec.key === 'city_id');
          let dd = cc.items.find(ret => ret.name === this.selected['city']);
          this.selected = Object.assign({ city_id: dd.id }, this.selected);
          delete this.selected['city'];
        }
        setTimeout(() => {
          this.selectOptions.map(rec => {
            rec.checked = this.selected[rec.key] ? (+this.selected[rec.key]) : 0;
            let pid; let cid;

            if (rec.key === 'position_industry_pid') {
              pid = 'position_industry_pid';
              cid = 'position_industry_cid';
              this.onInitChildren(pid, cid, rec); //处理期望岗位和岗位类型children
            } else if (rec.key === 'position_hope_pid') {
              pid = 'position_hope_pid';
              cid = 'position_hope_id';
              this.onInitChildren(pid, cid, rec); //处理期望岗位和岗位类型children
            }
          })
        }, 30)
      }
    }
  }
  //  初始化显示
  selectedChange() {
    let cc = this.selectOptions.find(rec => rec.key === 'city_id');
    setTimeout(() => {
      let dd = cc.items.find(ret => ret.name === this.selected['city']);
      if (!dd.id) {
        this.selected = Object.assign({ city_id: dd.id }, this.selected);
        delete this.selected['city'];
      }
    }, 60);
  }
  selectItem(key, id) {
    //城市信息处理

    key === 'city_id' && this.selectOptions.map(rec => {
      if (rec.key === 'city_id') {
        if (rec.items[0].id !== 0) { rec.items.splice(0, 1); }
      }
    });

    let tmp = this.selectOptions.find(rec => rec.key === key);
    let pid; let cid;
    if (tmp.key === 'position_industry_pid') {
      cid = 'position_industry_cid';
      if (id === 0) {
        this.selectOptions.find(rpt => rpt.key === cid).items = [{ id: 0, name: '不限' }];
        this.selectOptions.find(rpt => rpt.key === cid).checked = 0;
      }
    } else if (tmp.key === 'position_hope_pid') {
      cid = 'position_hope_id';
      if (id === 0) {
        this.selectOptions.find(rpt => rpt.key === cid).items = [{ id: 0, name: '不限' }];
        this.selectOptions.find(rpt => rpt.key === cid).checked = 0;
      }
    }

    tmp.checked = id;
    this.emitEvent();
  }

  emitEvent() {
    let tmp = this.selectOptions.filter(rec => rec.checked > 0);
    let re = {};
    tmp.length > 0 && (tmp.map(ret => {
      re[ret['key']] = +ret['checked'];
    }));
    if (this.setOptions.length === 7) { //如果是找人才
      //查看是否有城市选项，
      if (re['city_id']) {
        let cc = this.selectOptions.find(rec => rec.key === 'city_id');
        let dd = cc.items.find(ret => ret.id == re['city_id'])['name'];
        //如果有 将key city_id => city  value id => name
        re['city'] = dd;
        delete re['city_id'];
      }
    }
    setTimeout(() => {
      this.jobSelectType.emit(re);
    }, 10);
  }
  //打开或关闭模态框状态  显示是true  关闭是false
  showDialog() {
    this.display = true;
  }
  //获取模态框状态  显示是true  关闭是false
  dialogShow($evnet) {
    this.display ? this.display = false : this.display = true;
  }
  //获取选中的城市信息取选中的城市信息
  getCityData(event) {
    this.selectOptions.map(rec => {
      if (rec.key === 'city_id') {
        if (rec.items[0].id !== 0) {
          rec.items.splice(0, 1);
        }
        rec.items.unshift({ id: event.id, name: event.name });
        rec.checked = event.id;
        this.emitEvent();
      }
    })
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/category-option/category-option.component.ts